<template>
    <section>
        <el-form :inline="true" :model="dataForm" ref="lineForm">
            <el-form-item label="组织架构:" prop="departmentId">
                <TenantCustomersSelectVue v-model="dataForm.departmentId" style="width: 220px">
                </TenantCustomersSelectVue>
            </el-form-item>
            <el-form-item label="号码:" prop="Tel">
                <el-input type="textarea" v-model="dataForm.Tel" placeholder="请输入号码" clearable rows="1"></el-input>
            </el-form-item>
            <el-form-item label="所属运营商:" prop="SupplierName">
                <el-select v-model="dataForm.SupplierName" placeholder="请选择所属运营商" clearable>
                    <el-option :value="v.KeyTag" v-for="v in yysList" :key="v.KeyTag" :label="v.KeyTag">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间:">
                <el-date-picker :clearable="false" v-model="time" type="datetimerange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
                    @change="changeDate" :editable="false" @keydown.enter.native.stop @keydown.native.prevent>
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
            <el-form-item>
                <el-button @click="handleGetDataList" type="primary">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="RechargeAdd()" icon="el-icon-edit">手动充值</el-button>
            </el-form-item>
            <el-form-item>
                <el-button @click="upload()" icon="cloud-upload" type="primary">批量充值</el-button>
            </el-form-item>
            <el-form-item>
                <el-button @click="rechrageexportHandle()" icon="cloud-upload" type="primary">导出</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table :data="dataList" v-loading="dataListLoading" ref="table" class="custom-tbl" style="width: 100%">
            <el-table-column align="center" prop="DepartmentName" label="组织架构" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="Name" label="客户名称" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="Tel" label="手机号"></el-table-column>
            <el-table-column align="center" prop="SupplierName" label="所属运营商"></el-table-column>
            <el-table-column align="center" prop="Amount" label="充值金额">
                <template slot-scope="scope">
                    {{ Number(scope.row.Amount) === 0 ? '0.00' : (Number(scope.row.Amount) || '0.00').toFixed(2) }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="IsSuccess" label="执行结果">
                <template slot-scope="scope">
                    {{ scope.row.IsSuccess === true ? '成功' : (scope.row.IsSuccess === false ? '失败' : '未执行') }}
                </template></el-table-column>
            <el-table-column align="center" prop="Remark" label="备注"></el-table-column>
            <el-table-column align="center" prop="OperatorId" label="操作人"></el-table-column>
            <el-table-column align="center" prop="CreateTime" label="创建时间"></el-table-column>
        </el-table>
        <el-pagination @size-change="pageSizeChangeHandle1" @current-change="pageCurrentChangeHandle1"
            :current-page="page" :page-sizes="pageSizes" :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper" :total="total" style="float: right; margin-top: 15px">
        </el-pagination>
        <ImportRechargeNumber ref="ImportRechargeNumber" @ok="handleGetDataList"></ImportRechargeNumber>
        <ImportExcelRechargeNumber ref="ImportExcelRechargeNumber" @ok="handleGetDataList"></ImportExcelRechargeNumber>
    </section>
</template>

<script>
import viewModule from "@/mixins/view-module";
import ImportRechargeNumber from "./ImportRechargeNumber.vue";
import ImportExcelRechargeNumber from "./importExceRechargeNumber.vue";
import moment from "moment";
const starttime = moment(new Date()).format("yyyy-MM-DD 00:00:00");
const endtime = moment(new Date()).format("yyyy-MM-DD 23:59:59");
export default {
    components: { ImportRechargeNumber, ImportExcelRechargeNumber },
    mixins: [viewModule],
    props: {
        IsStop: {
            type: Boolean
        },
    },
    data() {
        return {
            time: [starttime, endtime],
            dataForm: {
                Tel: "",
                StartT: starttime,
                EndT: endtime,
                SupplierName: "",
                departmentId: "",
            },
            mixinViewModuleOptions: {
                requestMethod: "post",
                getDataListIsPage: true,
                getDataListURL: "/api/FilterCaller/PostAllTelRechargeList",
                rechrageURL: "/api/FilterCaller/ExportTelRechargeList",
                deleteURL: "",
            },
            yysList: [],
        }
    },
    mounted() {
        this.getYys();
    },
    methods: {
        upload() {
            this.$refs.ImportExcelRechargeNumber.init();
        },
        pageSizeChangeHandle1(val) {
            this.page = 1
            this.limit = val
            this.handleGetDataList()
        },
        pageCurrentChangeHandle1(val) {
            this.page = val
            this.handleGetDataList()
        },
        handleGetDataList() {
            const oldtel = JSON.parse(JSON.stringify(this.dataForm.Tel));
            if (typeof this.dataForm.Tel === 'string') {
                this.dataForm.Tel = this.dataForm.Tel.split("\n").filter((v) => !!v);
            }

            this.query();
            this.dataForm.Tel = oldtel;
        },
        RechargeAdd() {
            this.$refs.ImportRechargeNumber.init();
        },
        pageSizeChangeHandle1(val) {
            this.page = 1
            this.limit = val
            this.handleGetDataList()
        },
        pageCurrentChangeHandle1(val) {
            this.page = val
            this.handleGetDataList()
        },
        handleGetDataList() {
            const oldtel = JSON.parse(JSON.stringify(this.dataForm.Tel));
            if (typeof this.dataForm.Tel === 'string') {
                this.dataForm.Tel = this.dataForm.Tel.split("\n").filter((v) => !!v);
            }

            this.query();
            this.dataForm.Tel = oldtel;
        },
        downloadExcelFile(path) {
            window.open(path);
        },
        changeDate(e) {
            if (e) {
                // 调整时区偏移
                const start = new Date(e[0]);
                const end = new Date(e[1]);
                const offset = start.getTimezoneOffset() * 60000; // 毫秒
                this.dataForm.StartT = new Date(start.getTime() - offset).toISOString();
                this.dataForm.EndT = new Date(end.getTime() - offset).toISOString();
            } else {
                this.dataForm.StartT = "";
                this.dataForm.EndT = "";
            }
        },
        getYys() {
            this.$http
                .get("/api/common/GetDictionaryKeyVList?keyType=operators")
                .then((res) => {
                    console.log(res);
                    this.yysList = res.data.response.childrenList;
                });
        },
    },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
    display: none;
}
</style>
